import { render, staticRenderFns } from "./CandidateProfile.vue?vue&type=template&id=ce0d6496&scoped=true&"
import script from "./CandidateProfile.vue?vue&type=script&lang=js&"
export * from "./CandidateProfile.vue?vue&type=script&lang=js&"
import style0 from "./CandidateProfile.vue?vue&type=style&index=0&id=ce0d6496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0d6496",
  null
  
)

export default component.exports